import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { KPIType } from "@/types/kpiTypes.ts"

export const getTypes = async (): Promise<KPIType[]> => {
  const { data, error, response } = await apiClient.GET("/api/KPIs/types")
  return assertOk(response, error, data)
}
